export default __webpack_public_path__ + "static/media/right-arrow.2f9a987d.svg";